 <div mode="ios" class="card" *ngIf="!loading">
  <div class="card-content" *ngIf="couponListing; else nothing">
    <div  id="title-container">
      <h2>{{couponListing.name}}</h2>
    </div>
    <ion-item  style="text-align: center;">
      <ion-label color="secondary">
        <strong>{{couponListing.restaurant_name}} | {{couponListing.name}}</strong>
        <p>{{coupon.expirationDate_unix_utc | daysLeft}}</p>
      </ion-label>
    </ion-item>
    <div id="img-container" (click)="viewRestaurant(couponListing)"class="fade-in">
      <img  
      id="background-image"
      [defaultImage]="assetLinksService.avatarLoading" 
      [lazyLoad]="couponListing.picture" 
      [errorImage]="assetLinksService.noImage"
      onerror="this.src='assets/errorimg_ink.png'">
    </div> 
        <ion-item lines="none"  style="text-align: center;">
          <ion-label color="secondary">
            <strong>Redeem coupon</strong>
            <p>Choose a redemption method</p>
          </ion-label>
        </ion-item>
        <!-- <ion-grid fixed>
          <ion-row>
            <ion-col >
              <ion-button [disabled]="dateTimeService.isExpired(coupon.expirationDate_unix_utc) || isButtonLoading" expand="block" (click)="redeemCoupon('QR')" >
                {{isButtonLoading? '' : 'QR' }} 
                <ion-icon *ngIf="!isButtonLoading"  slot="end" name="scan"></ion-icon>
                <ion-spinner *ngIf="isButtonLoading" name="dots"></ion-spinner>
              </ion-button>
            </ion-col>
            <ion-col *ngIf="scanService.isNfcSupported" >
              <ion-button [disabled]="dateTimeService.isExpired(coupon.expirationDate_unix_utc) || isButtonLoading" expand="block" (click)="redeemCoupon('NFC')" >
                {{isButtonLoading? '' : 'NFC' }} 
                <ion-icon *ngIf="!isButtonLoading"  slot="end" name="radio"></ion-icon>
                <ion-spinner *ngIf="isButtonLoading" name="dots"></ion-spinner>
              </ion-button>
            </ion-col>
            <ion-col>
              <ion-button [disabled]="dateTimeService.isExpired(coupon.expirationDate_unix_utc) || isButtonLoading" expand="block" (click)="showRedemptionQrCode()" >
                {{isButtonLoading? '' : 'SHOW' }} 
                <ion-icon *ngIf="!isButtonLoading" slot="end"  name="qr-code"></ion-icon>
                <ion-spinner *ngIf="isButtonLoading" name="dots"></ion-spinner>
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid> -->
         <ion-button style="padding: 1em;"  [disabled]="dateTimeService.isExpired(coupon.expirationDate_unix_utc) || isButtonLoading" expand="block"  (click)="showRedemptionOptions()" >
          {{isButtonLoading? '' : 'Redeem Coupon' }} 
          <ion-icon *ngIf="!isButtonLoading"  slot="end" name="gift"></ion-icon>
          <ion-spinner *ngIf="isButtonLoading" name="dots"></ion-spinner>
        </ion-button>
  </div>
  <ng-template #nothing>
    <div class="card-content">
      <div  id="title-container">
        <h2>Error</h2>
      </div>
      <div id="img-container" class="fade-in">
        <img  
        id="background-image"
        [defaultImage]="assetLinksService.cardLoading" 
        [lazyLoad]="assetLinksService.noImage" 
        [errorImage]="assetLinksService.noImage"
        onerror="this.src='assets/errorimg_ink.png'">
      </div>
        <ion-item  style="text-align: center;">
          <ion-label color="secondary">
            <strong>Error fetching coupon</strong>
            <p>
              Please check your internet connection.
              Try closing the app completely (not just minimize) 
              and re-open the app
            </p>
          </ion-label>
        </ion-item>
        <div id="redeem-button-container">
   
        </div>
    </div>
  </ng-template>
</div> 
<!-- 
 <div class="coupon" *ngIf="!loading">
  <ion-avatar style="position: absolute;
  width: 7em;
  height: 7em;
  left: 0;
  bottom: 0;">
    <img [src]="couponListing.picture" />
  </ion-avatar>
  <div *ngIf="couponListing; else nothing" style="width:100%;">
    
    <div class="top">
      <div>{{couponListing.restaurant_name}}</div>
    </div>
    <div class="mid">
      <div>
        <h2>{{couponListing.name}}</h2>
        <h3>Coupon</h3>
        <small>{{coupon.expirationDate_unix_utc | daysLeft}}</small>
      </div>
      <ion-button [disabled]="dateTimeService.isExpired(coupon.expirationDate_unix_utc) || isButtonLoading" expand="block" fill="clear"  (click)="showRedemptionOptions()" >
        {{isButtonLoading? '' : 'Redeem Coupon' }} 
        <ion-icon *ngIf="!isButtonLoading"  slot="end" name="gift"></ion-icon>
        <ion-spinner *ngIf="isButtonLoading" name="dots"></ion-spinner>
      </ion-button>
    </div>
    
    <div class="bottom">
      <div>87878521112</div>
    </div>
  </div>
 
  <ng-template #nothing>
    <div class="card-content">
      <div  id="title-container">
        <h2>Error</h2>
      </div>
      <div id="img-container" class="fade-in">
        <img  
        id="background-image"
        [defaultImage]="assetLinksService.cardLoading" 
        [lazyLoad]="assetLinksService.noImage" 
        [errorImage]="assetLinksService.noImage"
        onerror="this.src='assets/errorimg_ink.png'">
      </div>
        <ion-item  style="text-align: center;">
          <ion-label color="secondary">
            <strong>Error fetching coupon</strong>
            <p>
              Please check your internet connection.
              Try closing the app completely (not just minimize) 
              and re-open the app
            </p>
          </ion-label>
        </ion-item>
        <div id="redeem-button-container">
   
        </div>
    </div>
  </ng-template>
  
</div>  -->

<div
style="height: 50vh; margin: 0.5em;"
mode="ios"
*ngIf="loading">
<ion-skeleton-text animated style="width: 100%;height: 100%;"></ion-skeleton-text>
</div>